import { Injectable } from '@angular/core';

/**
 * Remembers the last tenant app URL outside `/admin/*` so "Exit Admin Portal"
 * can return there instead of always routing to leads.
 */
@Injectable({
  providedIn: 'root',
})
export class AdminPortalReturnUrlService {
  private lastNonAdminUrl: string | null = null;

  /** Call on each successful navigation (e.g. NavigationEnd). */
  recordNavigationIfApplicable(fullUrl: string): void {
    const path = fullUrl.split('?')[0];
    if (this.isTenantAdminPath(path)) {
      return;
    }
    const tenantId = this.tenantIdFromPath(path);
    if (!tenantId) {
      return;
    }
    this.lastNonAdminUrl = fullUrl;
  }

  getReturnUrlForTenant(tenantId: string): string | null {
    const url = this.lastNonAdminUrl;
    if (!url) {
      return null;
    }
    const path = url.split('?')[0];
    if (this.tenantIdFromPath(path) !== tenantId || this.isTenantAdminPath(path)) {
      return null;
    }
    return url;
  }

  clear(): void {
    this.lastNonAdminUrl = null;
  }

  private tenantIdFromPath(path: string): string | null {
    const m = path.match(/^\/([^/]+)/);
    return m ? m[1] : null;
  }

  private isTenantAdminPath(path: string): boolean {
    return /^\/[^/]+\/admin(\/|$)/.test(path);
  }
}
